// Module
var code = `<div> <ui-select ng-model="\$ctrl.timeZone"> <ui-select-match placeholder="Search/Select a timezone">{{ \$select.selected.name }}</ui-select-match> <ui-select-choices repeat="date_time_tz in \$ctrl.available_timezones | filter: \$select.search"> {{date_time_tz.name}} </ui-select-choices> </ui-select> </div>`;
// Exports
module.exports = code;